module.exports = __webpack_public_path__ + "static/M2.99aaf64e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/M2.jpg
// module id = 464
// module chunks = 37721738025407